import React, { useState } from 'react';
import { Loader2, Tags } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { bapi } from '@/lib/billingApi';

export const PaypalBackfillCard = () => {
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const run = async (dryRun) => {
    setBusy(true);
    setResult(null);
    try {
      const data = await bapi('/admin/backfill-paypal-custom-ids', { method: 'POST', query: { dry_run: dryRun ? 'true' : 'false' } });
      setResult(data);
      toast.success(dryRun ? `Preview: would patch ${data.would_patch} · already tagged ${data.already_tagged}`
        : `Patched ${data.patched} · failed ${data.failed?.length || 0}`);
    } catch (e) { toast.error(e.message || 'Backfill failed'); } finally { setBusy(false); }
  };

  return (
    <Card className="border-amber-200 bg-amber-50/40">
      <CardHeader className="pb-3"><CardTitle className="text-base flex items-center gap-2"><Tags className="w-4 h-4 text-amber-700" />Backfill PayPal custom_id</CardTitle></CardHeader>
      <CardContent className="space-y-3">
        <p className="text-sm text-slate-600 leading-relaxed">
          Tags older PayPal subscriptions with a <code className="bg-white px-1 rounded">custom_id</code> pointing back to the Schedule Guru account, so webhooks and payout lines show the reference.
          Already-tagged subscriptions are skipped. Run <strong>Preview</strong> first.
        </p>
        <div className="flex flex-wrap gap-2">
          <Button variant="outline" onClick={() => run(true)} disabled={busy} data-testid="backfill-preview-btn">{busy && <Loader2 className="w-4 h-4 mr-1 animate-spin" />}Preview</Button>
          <Button onClick={() => run(false)} disabled={busy} className="bg-amber-500 hover:bg-amber-600 text-white" data-testid="backfill-commit-btn">{busy && <Loader2 className="w-4 h-4 mr-1 animate-spin" />}Run Backfill</Button>
        </div>
        {result && <pre className="text-xs bg-white border border-slate-200 rounded p-3 overflow-x-auto" data-testid="backfill-result">{JSON.stringify(result, null, 2)}</pre>}
      </CardContent>
    </Card>
  );
};
